/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import DynamicFormComponent from '../Form/DynamicFormComponent'
import OptionsSelector from './OptionsSelector'
import { v4 as uuidv4 } from 'uuid'
import { translate, useSmartTranslation } from '../../cls/TranslationContext'

/**
 * Predefined platform configurations, each with a unique ID, display label,
 * and an array of input definitions (label, type, and optional default value).
 */
const platformOptions = [
	{
		id: 'facebook',
		label: translate('platform.facebook.account'),
		inputs: [
			{ label: translate('platform.facebook.username'), type: 'text' },
			{
				label: translate('platform.facebook.link'),
				type: 'link',
				value: 'https://www.facebook.com'
			},
			{ label: translate('platform.facebook.password'), type: 'password' }
		]
	},
	{
		id: 'instagram',
		label: translate('platform.instagram.account'),
		inputs: [
			{ label: translate('platform.instagram.username'), type: 'text' },
			{
				label: translate('platform.instagram.link'),
				type: 'link',
				value: 'https://www.instagram.com'
			},
			{
				label: translate('platform.instagram.password'),
				type: 'password'
			}
		]
	},
	{
		id: 'linkedIn',
		label: translate('platform.linkedin.account'),
		inputs: [
			{
				label: translate('platform.linkedin.username'),
				type: 'text'
			},
			{
				label: translate('platform.linkedin.link'),
				type: 'link',
				value: 'https://www.linkedin.com'
			},
			{ label: translate('platform.linkedin.password'), type: 'password' }
		]
	}
]

/**
 * PrewritePlatform component allows users to select a social platform from a dropdown,
 * then automatically injects its predefined set of inputs into the form under the `inputs` field.
 *
 * @component
 * @param {Object} props
 * @param {import('antd').FormInstance} props.form
 *   – Ant Design Form instance, used to read and write the `inputs` and `name` fields.
 * @param {boolean} [props.viewOnly=false]
 *   – If true, renders the DynamicFormComponent in read-only mode.
 * @returns {JSX.Element} Rendered platform selector and dynamic inputs list.
 */
const PrewritePlatform = ({ form, viewOnly }) => {
	/**
	 * Inserts the selected platform’s inputs into the form.
	 * Reads existing `inputs` array from the form, appends the new inputs,
	 * and updates the `name` field to the platform’s display label.
	 *
	 * @param {string} value – The `id` of the selected platform.
	 */
	const insertPrewritePlatform = (value) => {
		const selectedPlatform = platformOptions.find((p) => p.id === value)
		const existingPlatforms = form.getFieldValue('inputs') || []
		const newFields = selectedPlatform.inputs.map((input) => ({
			id: uuidv4(),
			type: input.type,
			label: input.label,
			value: input?.value || ''
		}))

		form.setFieldsValue({
			name: selectedPlatform.label,
			description: selectedPlatform?.description || '',
			inputs: [...existingPlatforms, ...newFields]
		})
	}

	const { t } = useSmartTranslation()

	return (
		<div>
			{/* <Form.Item className="item-no-label" label=" ">
				<OptionsSelector
					options={platformOptions.map((p) => ({
						label: p.label,
						value: p.id
					}))}
					value={null}
					onChange={insertPrewritePlatform}
					placeholder={t('__select.item%_platform')}
					dropdownMinWidth="250px"
				/>
			</Form.Item>wrapperCol */}
			<Form.Item className="item-no-label" label=" " name="inputs">
				<DynamicFormComponent
					viewOnly={viewOnly}
					form={form}
					value={form.getFieldValue('inputs') || []}
					onChange={(newValue) =>
						form.setFieldsValue({ inputs: newValue })
					}
				/>
			</Form.Item>
		</div>
	)
}

PrewritePlatform.propTypes = {
	form: PropTypes.object.isRequired,
	viewOnly: PropTypes.bool
}

export default PrewritePlatform
